/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
// import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import AppConfigRobotType from '~/components/AppConfigRobotType';
import LocaleMessage from '~/components/LocaleMessage';
// import Splash from '~/components/Splash/Inside';

// import getDateLocale from '~/util/GetDateLocale';
import GetPluginspaceTheme from '~/util/PluginspaceTheme';

import { Column, SettingsArea } from '../styles';
import DeliveryPage from './DeliveryPage';
// import LoginPage from './LoginPage';
import StandbyPage from './StandbyPage';

// const type_features = {
//     pudubot: {
//     },
//     temi_go: {
//         reference_point_id: true,
//     },
// };

export default function Visual({
    app,
    robotTypes,
    currType,
    setCurrType,
    updateObject,
    setToast,
    handleError,
    imageGalleriesList,
    defaultGalleries,
    setNeedSaving,
    // needSaving,
}) {
    const theme = GetPluginspaceTheme(useTheme());

    // const user_settings = useSelector(state => state.settings || null);
    // const date_loc = getDateLocale(user_settings);
    // const def_lang =
    //     date_loc && date_loc.code ? date_loc.code.replace('-', '_') : 'en_US';

    const appSettings = app && app.settings ? app.settings : {};
    const visualSettings = appSettings.visual || {};

    // const [isLoading, setIsLoading] = useState(false);
    const [config, setConfig] = useState(visualSettings);

    const defImageGalleries = defaultGalleries.images || [];
    const galleriesList = [...imageGalleriesList, ...defImageGalleries];

    const r_key = currType.slug ? currType.slug : 'all';
    const r_type_settings = config[r_key] || {};
    // const robot_features = type_features[r_key] || {};

    async function handleSubmit() {
        const data = { visual: config };
        updateObject(data);
    }

    function setCurrTypeSettings(key, value) {
        setNeedSaving(true);
        const updated = {
            ...config,
            [r_key]: {
                ...r_type_settings,
                [key]: value,
            },
        };
        setConfig(updated);
    }

    function renderSubmitButton() {
        return (
            <div className="col-12 mt-2">
                <Button
                    className="p-3"
                    variant="contained"
                    color="primary"
                    onClick={() => handleSubmit()}
                    fullWidth
                    size="large"
                    // disabled={!needSaving}
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </div>
        );
    }

    function renderVisualConfig() {
        return (
            <Column>
                <SettingsArea className="row col-12">
                    <div className="col-12" style={{ margin: '20px' }}>
                        {/* <MainParameters
                            colors={colors}
                            settings={config}
                            setSettings={(k, v) => setCurrTypeSettings(k, v)}
                        /> */}
                        {/* <LoginPage
                            pageKey="login_page"
                            pageTitle="page.applications.indoor_delivery.form.preview.login.title"
                            settings={config}
                            galleries={galleriesList}
                            currFile={currFile}
                            setCurrFile={f => setCurrFile(f)}
                            updateFile={f => setCurrFile(f)}
                            setToast={toast => setToast(toast)}
                            handleError={error => handleError(error)}
                            setSettings={(k, v) => setCurrTypeSettings(k, v)}
                            allowedSettings={{
                                logo: true,
                                image: true,
                            }}
                            robot={{}}
                            file={currFile}
                            configuration={config}
                            defColors={defColors}
                            refreshedImage={currFile}
                        /> */}
                        <StandbyPage
                            theme={theme}
                            pageKey="standby_page"
                            pageTitle="page.applications.indoor_delivery.form.preview.standby.title"
                            settings={r_type_settings}
                            setSettings={(k, v) => setCurrTypeSettings(k, v)}
                            galleries={galleriesList}
                            setToast={toast => setToast(toast)}
                            handleError={error => handleError(error)}
                        />
                        <DeliveryPage
                            theme={theme}
                            pageKey="delivery_page"
                            pageTitle="page.applications.indoor_delivery.form.preview.delivery.title"
                            settings={r_type_settings}
                            setSettings={(k, v) => setCurrTypeSettings(k, v)}
                            galleries={galleriesList}
                            setToast={toast => setToast(toast)}
                            handleError={error => handleError(error)}
                        />
                    </div>
                </SettingsArea>
            </Column>
        );
    }

    return (
        <div className="col-12 mb-3 row">
            <div className="sidecard-header">
                <h2>
                    <LocaleMessage msg="label.settings.app.indoor_delivery.visual" />
                </h2>
            </div>
            <div className="sidecard-body">
                {/* {isLoading ? (
                    <Splash />
                ) : ()} */}
                <AppConfigRobotType
                    className="col-12 mb-5"
                    robotTypes={robotTypes}
                    currType={currType}
                    setCurrType={t => setCurrType(t)}
                >
                    <>
                        {renderVisualConfig()}
                        <div
                            className="col-md-8 col-12 row mt-3 mb-5"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {renderSubmitButton()}
                        </div>
                    </>
                </AppConfigRobotType>
            </div>
        </div>
    );
}

Visual.defaultProps = {
    imageGalleriesList: [],
    defaultGalleries: {},
};

Visual.propTypes = {
    app: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
    robotTypes: PropTypes.array.isRequired,
    currType: PropTypes.object.isRequired,
    setCurrType: PropTypes.func.isRequired,
    setToast: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,
    imageGalleriesList: PropTypes.array,
    defaultGalleries: PropTypes.object,
    setNeedSaving: PropTypes.func.isRequired,
    // needSaving: PropTypes.bool.isRequired,
};
